exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-theme-default a:not(.md-button),.theme--light.v-list .v-list__tile--link,.theme--light.v-list .v-list__tile--link:hover{color:rgba(0,0,0,.87);text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3575680c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Sidebar.vue
// module id = sT6/
// module chunks = 34